export const LOOKUP_DEFAULT_METADATA_COLUMN = "__is_default";

const TRUE_VALUES = new Set(["yes", "true", "1", "y", "default"]);
const FALSE_VALUES = new Set(["", "no", "false", "0", "n"]);

export function parseLookupDefaultFlags(
  values: unknown[],
): { ok: true; flags: boolean[] } | { ok: false; value: string } {
  const flags: boolean[] = [];
  for (const raw of values) {
    const normalized = String(raw ?? "")
      .trim()
      .toLowerCase();
    if (!TRUE_VALUES.has(normalized) && !FALSE_VALUES.has(normalized)) {
      return { ok: false, value: normalized };
    }
    flags.push(TRUE_VALUES.has(normalized));
  }
  return { ok: true, flags };
}
